import { ResourceType } from '@cotera/api';
import { agentChatSeedStrategy } from '../agent/seed';
import { workflowChatSeedStrategy } from '../workflow/chat-seed';
import { datasetChatSeedStrategy } from '../dataset/chat-seed';
import type { ChatSeedStrategy } from './types';

const CHAT_SEED_STRATEGIES: readonly ChatSeedStrategy[] = [
  agentChatSeedStrategy,
  workflowChatSeedStrategy,
  datasetChatSeedStrategy,
];

const strategyByType = new Map<string, ChatSeedStrategy>(
  CHAT_SEED_STRATEGIES.map((strategy) => [strategy.type, strategy])
);

export function getChatSeedStrategy(
  type: string
): ChatSeedStrategy | undefined {
  return strategyByType.get(type);
}

export function listChatSeedStrategies(): readonly ChatSeedStrategy[] {
  return CHAT_SEED_STRATEGIES;
}

/**
 * The seed that opens a resource of this type as a chat artifact, if any.
 *
 * Covers every {@link ResourceType}, folders included: the registry decides
 * which types it claims, and a folder is simply one no strategy names. Keyed by
 * `NonFolderResourceType` it was the caller's job to know that, so every caller
 * carried its own `=== Folder` branch to avoid a type error over a lookup that
 * would have returned `undefined` anyway. Same lesson as `resourceKind`.
 */
export function getChatSeedStrategyForResourceType(
  type: ResourceType
): ChatSeedStrategy | undefined {
  return CHAT_SEED_STRATEGIES.find(
    (strategy) => strategy.artifactResourceType === type
  );
}
